module.exports = __webpack_public_path__ + "static/media/icon-48.4c97df36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-48.jpg
// module id = 2008
// module chunks = 4